import { useGtm } from "@gtm-support/vue-gtm";
import Vuex from 'vuex';
import store from '@/store';

var gtm = useGtm();
var internalClick = "iClick";
var externalClick = "eClick";

//create internal API to call on events
const gtmService = {
    pushAppType() {
        if (gtm.enabled()) {
            dataLayer.push({
                'app-type': 'Plugin'
            });
        }
    },
    pushAdUnitEvent(action, label, sourceMfrName, sourceMfrPN, mfrName, mfrPN, advertiser) {
        if (gtm.enabled()) {
            dataLayer.push({
                'event': 'pclick',
                'event-category': 'ad unit',
                'event-action': action,
                'event-label': label,
                'source-manufacturer': sourceMfrName,
                'source-manufacturer-pn': sourceMfrPN,
                'manufacturer': mfrName,
                'manufacturer-pn': mfrPN,
                'advertiser': advertiser
            });
        }
    },
    pushVedaEvent(category, action, label, sourceMfrName, sourceMfrPN, mfrName, mfrPN, advertiser) {
        if (gtm.enabled()) {
            dataLayer.push({
                'event': 'Veda',
                'event-category': category,
                'event-action': action,
                'event-label': label,
                'source-manufacturer': sourceMfrName,
                'source-manufacturer-pn': sourceMfrPN,
                'manufacturer': mfrName,
                'manufacturer-pn': mfrPN,
                'advertiser': advertiser
            });
        }
    },
    pushPaidLink(linkText, mfrName, mfrPN, distributor) {
        if (gtm.enabled()) {
            dataLayer.push({
                'event': 'pclick',
                'event-category': 'external link click',
                'event-action': 'pClick',
                'event-label': linkText,
                'manufacturer-pn': mfrPN,
                'manufacturer': mfrName,
                'distributor': distributor
            });
        }
    },
    // Event when a part details page is opened
    pushPartData(manufacturer, manufacturerPN) {
        if (gtm.enabled()) {
            dataLayer.push({
                'manufacturer': manufacturer,
                'manufacturer-pn': manufacturerPN
            });
        }
    },
    // Main download event that sends all exports in the action
    pushDownloadRequestEvent(category, mfrName, mfrPN, numExports, cadProductsString, cadSettingString, status) {
        if (gtm.enabled()) {
            dataLayer.push({
                'event': 'ulPartRequest',
                'event-category': category,
                'event-action': numExports + 'CAD Formats Generated ' + cadProductsString,
                'event-label': mfrName,
                'action-status': status,
                'manufacturer-pn': mfrPN,
                'download-settings': cadSettingString
            });
        }
    },
    // secondary download event that sends an event for each format downloaded
    pushDownloadFormatEvent(category, action, mfrName, mfrPN, cadFamily, cadProduct, cadVersion, cadSettingString, status) {
        // event-categories should be all lowercase
        if (gtm.enabled()) {
            dataLayer.push({
                'event': 'partEvent',
                'event-category': category.toLowerCase(),
                'event-action': action,
                'event-label': mfrName,
                'manufacturer-pn': mfrPN,
                'cad-family': (cadFamily !== null ? cadFamily : '<blank>'),
                'cad-product': (cadProduct !== null ? cadProduct : '<blank>'),
                'cad-version': (cadVersion !== null ? cadVersion : '<blank>'),
                'action-status': status,
                'download-settings': cadSettingString
            });
        }
    },
    pushFailureTriggerEvent(mfrName, mfrPN, numExports, cadProductsString, status) {
        if (gtm.enabled()) {
            dataLayer.push({
                'event': 'ulPartRequest',
                'event-category': 'download error',
                'event-action': numExports + ' CAD Formats Generated ' + cadProductsString,
                'event-label': mfrName,
                'action-status': status,
                'manufacturer-pn': mfrPN
            });
        }
    },
    // Event pushed the first page load after a user logs in
    pushCustomerEvent(ulAppCustomerID) {
        if (gtm.enabled()) {
            dataLayer.push({
                'event': 'dataCollection',
                'event-category': 'app info',
                'event-action': 'data collection',
                'ulapp-custid': ulAppCustomerID
            });
        }
    },
    // Event pushed when a user first registers with label = 'started' and then a second event when they confirm there email = 'confirmed'
    pushRegistration(label) {
        if (gtm.enabled()) {
            dataLayer.push({
                'event': 'userSignUp',
                'event-category': 'acquisition',
                'event-action': 'registration',
                'event-label': label
            });
        }
    },
    // Event pushed when an influenced search ad is shown. Will be send as an impression when it is loaded and if the user clicks one of the links a second event will be sent
    // type can be: ref des | keyword | competitive | highlight
    // 
    pushInfluencedSearchEvent(action, label, type, mfr, mfrPN, term, advertiser) {
        label = 'Influenced Search ' + label;

        if (gtm.enabled()) {
            dataLayer.push({
                'event': 'pclick',
                'event-category': 'ad unit',
                'event-action': action,
                'event-label': label,
                'event-type': type,
                'manufacturer': mfr,
                'manufacturer-pn': mfrPN,
                'term': term,
                'advertiser': advertiser
            });
        }
    },
    pushManufacturerPanelEvent(mfrName, mfrPN) {
        if (gtm.enabled()) {
            dataLayer.push({
                'event': 'manufacturerPanel',
                'manufacturer': mfrName,
                'manufacturer-pn': mfrPN
            });
        }
    },
    pushCompetitivePartImpression(sourceMfrName, sourceMfrPN, mfrName, mfrPN, advertiser) {
        this.pushAdUnitEvent('impressions', 'Cross Reference', sourceMfrName, sourceMfrPN, mfrName, mfrPN, advertiser);
    },
    pushCompetitivePartClickInternal(sourceMfrName, sourceMfrPN, mfrName, mfrPN, advertiser) {
        this.pushAdUnitEvent(internalClick, 'Cross Reference', sourceMfrName, sourceMfrPN, mfrName, mfrPN, advertiser);
    },
    pushCompetitivePartClickExternal(sourceMfrName, sourceMfrPN, mfrName, mfrPN, advertiser) {
        this.pushAdUnitEvent(externalClick, 'Cross Reference', sourceMfrName, sourceMfrPN, mfrName, mfrPN, advertiser);
    },
    pushRelatedPartImpression(sourceMfrName, sourceMfrPN, mfrName, mfrPN, advertiser) {
        this.pushAdUnitEvent('impressions', 'Related Product', sourceMfrName, sourceMfrPN, mfrName, mfrPN, advertiser);
    },
    pushRelatedPartClickInternal(sourceMfrName, sourceMfrPN, mfrName, mfrPN, advertiser) {
        this.pushAdUnitEvent(internalClick, 'Related Product', sourceMfrName, sourceMfrPN, mfrName, mfrPN, advertiser);
    },
    pushRelatedPartClickExternal(sourceMfrName, sourceMfrPN, mfrName, mfrPN, advertiser) {
        this.pushAdUnitEvent(externalClick, 'Related Product', sourceMfrName, sourceMfrPN, mfrName, mfrPN, advertiser);
    },
    pushPartDetailsReferenceDesignImpression(sourceMfrName, sourceMfrPN, mfrName, mfrPN, advertiser) {
        this.pushVedaEvent('Ref Des Related Parts', 'impressions', 'Reference Design', sourceMfrName, sourceMfrPN, mfrName, mfrPN, advertiser);
    },
    pushPartDetailsReferenceDesignClickInternal(sourceMfrName, sourceMfrPN, mfrName, mfrPN, advertiser) {
        this.pushVedaEvent('Ref Des Related Parts', internalClick, 'Reference Design', sourceMfrName, sourceMfrPN, mfrName, mfrPN, advertiser);
    },
    pushPartDetailsReferenceDesignClickExternal(sourceMfrName, sourceMfrPN, mfrName, mfrPN, advertiser) {
        this.pushVedaEvent('Ref Des Related Parts', externalClick, 'Reference Design', sourceMfrName, sourceMfrPN, mfrName, mfrPN, advertiser);
    },
    pushReferenceDesignImpression(mfrName, mfrPN) {
        if (gtm.enabled()) {
            dataLayer.push({
                'event': 'Veda',
                'event-category': 'Ref Des Details Page',
                'event-action': 'impressions',
                'event-label': 'Reference Design',
                'manufacturer': mfrName,
                'manufacturer-pn': mfrPN
            });
        }
    },
    pushReferenceDesignClickExternal(mfrName, mfrPN) {
        if (gtm.enabled()) {
            dataLayer.push({
                'event': 'Veda',
                'event-category': 'Ref Des Details Page',
                'event-action': externalClick,
                'event-label': 'Reference Design',
                'manufacturer': mfrName,
                'manufacturer-pn': mfrPN
            });
        }
    },
    pushReferenceDesignRelatedPartClickInternal(sourceMfrName, sourceMfrPN, mfrName, mfrPN) {
        if (gtm.enabled()) {
            dataLayer.push({
                'event': 'Veda',
                'event-category': 'Ref Des Details Page',
                'event-action': internalClick,
                'event-label': 'Related Product',
                'source-manufacturer': sourceMfrName,
                'source-manufacturer-pn': sourceMfrPN,
                'manufacturer': mfrName,
                'manufacturer-pn': mfrPN
            });
        }
    },
    pushReferenceDesignRelatedPartClickExternal(sourceMfrName, sourceMfrPN, mfrName, mfrPN) {
        if (gtm.enabled()) {
            dataLayer.push({
                'event': 'Veda',
                'event-category': 'Ref Des Details Page',
                'event-action': externalClick,
                'event-label': 'Related Product',
                'source-manufacturer': sourceMfrName,
                'source-manufacturer-pn': sourceMfrPN,
                'manufacturer': mfrName,
                'manufacturer-pn': mfrPN
            });
        }
    },
    pushReferenceDesignDownload(mfrName, mfrPN, cadProduct) {
        if (gtm.enabled()) {
            dataLayer.push({
                'event': 'Veda',
                'event-category': 'Ref Des Details Page',
                'event-action': 'downloads',
                'event-label': 'Reference Design',
                'manufacturer': mfrName,
                'manufacturer-pn': mfrPN,
                'cad-product': cadProduct
            });
        }
    },
    pushSearchEvent(search, mfr, queryType, numResults) {
        if (search == '')
            search = '<blank>';
        if (mfr == '')
            mfr = '<blank>';
        if (numResults == 0)
            search += '<no-results>';
        if (gtm.enabled()) {
            dataLayer.push({
                'event': 'eventSearch',
                'vpv': '/search?queryText=' + search + +'&mfr=' + mfr + '&queryType=' + queryType,
                'vpv-title': 'Ultra Librarian Cad Plugin - Search Results'
            });
        }
    },
    pushPartEvent(category, action, mfrName, mfrPN, cadFamily, cadProduct, cadVersion, cadSettingString, status) {
        if (cadVersion == '')
            cadVersion = '<blank>';
        // event-categories should be all lowercase
        if (gtm.enabled()) {
            dataLayer.push({
                'event': 'partEvent',
                'event-category': category.toLowerCase(),
                'event-action': action,
                'event-label': mfrName,
                'manufacturer-pn': mfrPN,
                'cad-family': (cadFamily != null ? cadFamily : '<blank>'),
                'cad-product': (cadProduct != null ? cadProduct : '<blank>'),
                'cad-version': (cadVersion != null ? cadVersion : '<blank>'),
                'action-status': status,
                'download-settings': cadSettingString
            });
        }
    },
}


const gtmPlugin = store => {
    store.subscribeAction(async (action) => {
        if (!gtm)
            gtm = useGtm();

        switch (action.type) {
            case 'gtmNewAccess':
                //Set app type
                gtmService.pushAppType();
                //Check user Login
                if (action.payload)
                    gtmService.pushCustomerEvent(action.payload.userId)
                break;
            case 'gtmSubmitRegistration':
                gtmService.pushRegistration('started');
                break;
            case 'gtmConfirmRegistration':
                gtmService.pushRegistration('confirmed');
                break;

            case 'gtmDownloadComplete':
                var downloadContent = action.payload;
                var downloadStatus = 'success';
                gtmService.pushDownloadRequestEvent(
                    'ul vuecad plugin part download',
                    downloadContent.mfrName,
                    downloadContent.mfrPN,
                    downloadContent.count,
                    downloadContent.productString,
                    downloadContent.cadSettingsString,
                    downloadStatus
                );
                for (var i = 0; i < downloadContent.typeModels.length; i++) {
                    for (var j = 0; j < downloadContent.typeModels[i].libraryTypes.length; j++) {
                        gtmService.pushDownloadFormatEvent(
                            downloadContent.typeModels[i].libraryTypes[j],
                            'download',
                            downloadContent.mfrName,
                            downloadContent.mfrPN,
                            downloadContent.typeModels[i].cadFamily,
                            downloadContent.typeModels[i].cadProduct,
                            downloadContent.typeModels[i].cadVersion,
                            downloadContent.cadSettingsString,
                            downloadStatus);
                    }
                }
                break;
            case 'gtmDownloadFailure':
                var failureContent = action.payload;
                var failureStatus = 'failure';
                gtmService.pushFailureTriggerEvent(failureContent.mfrName, failureContent.mfrPN, failureContent.typeModels.length, failureContent.cadSettingsString, failureStatus);
                break;
            case 'gtmReferenceDownload':
                gtmService.pushReferenceDesignDownload(action.payload.mfrName, action.payload.mfrPN, action.payload.cadProduct);
                break;
            case 'gtmReferenceInfluence':
                gtmService.pushReferenceDesignImpression(action.payload.mfrName, action.payload.mfrPN);
                break;
            case 'gtmSearch':
                gtmService.pushSearchEvent(action.payload.search, action.payload.mfr, action.payload.queryType, action.payload.numResults);
                var influencedSearchResult = action.payload.influencedSearchResult;
                if (influencedSearchResult != null)
                    gtmService.pushInfluencedSearchEvent('influenced', influencedSearchResult.eventLabel, influencedSearchResult.eventType, influencedSearchResult.manufacturerName, influencedSearchResult.manufacturerPartNumber, influencedSearchResult.term, influencedSearchResult.advertiserName);
                break;
            case 'gtmPartLoaded':
                gtmService.pushPartData(action.payload.mfrName, action.payload.mfrPN);
                break;
            case 'gtmCompatiblePart':
                gtmService.pushRelatedPartImpression(action.payload.sourceMfrName, action.payload.sourceMfrPN, action.payload.mfrName, action.payload.mfrPN, action.payload.advertiser);
                break;
            case 'gtmCompatibleInternal':
                gtmService.pushRelatedPartClickInternal(action.payload.sourceMfrName, action.payload.sourceMfrPN, action.payload.mfrName, action.payload.mfrPN, action.payload.advertiser);
                break;
            case 'gtmCompatibleExternal':
                gtmService.pushRelatedPartClickExternal(action.payload.sourceMfrName, action.payload.sourceMfrPN, action.payload.mfrName, action.payload.mfrPN, action.payload.advertiser);
                break;
            case 'gtmCompetitivePart':
                gtmService.pushCompetitivePartImpression(action.payload.sourceMfrName, action.payload.sourceMfrPN, action.payload.mfrName, action.payload.mfrPN, action.payload.advertiser);
                break;
            case 'gtmCompetitiveInternal':
                gtmService.pushCompetitivePartClickInternal(action.payload.sourceMfrName, action.payload.sourceMfrPN, action.payload.mfrName, action.payload.mfrPN, action.payload.advertiser);
                break;
            case 'gtmCompetitiveExternal':
                gtmService.pushCompetitivePartClickExternal(action.payload.sourceMfrName, action.payload.sourceMfrPN, action.payload.mfrName, action.payload.mfrPN, action.payload.advertiser);
                break;
            case 'gtmInfluenceSearch':
                gtmService.pushInfluencedSearchEvent(action.payload.action, action.payload.label, action.payload.type, action.payload.mfr, action.payload.mfrPN, action.payload.term, action.payload.advertiser);
                break;
        }
    });
}

export { gtmService, gtmPlugin };